import { taxonomyTypeValues } from '@/configuration/pages/ConfigurationPage/constants'

export const taxonomyTypes = [
  {
    label: 'Categorías de producto',
    value: taxonomyTypeValues.category,
  },
  {
    label: 'Tipos de producto',
    value: taxonomyTypeValues.productType,
  },
  {
    label: 'Colecciones',
    value: taxonomyTypeValues.collection,
  },
]
